import { combineReducers } from 'redux';
import happenings, * as fromHappenings from './happenings/';
import themes, * as fromThemes from './themes/';
import locations, * as fromLocations from './locations/';
import editions, * as fromEditions from './editions/';
import workshops, * as fromWorkshops from './workshops/';
import projects, * as fromProjects from './projects/';
import related, * as fromRelated from './related/';
import people, * as fromPeople from './people/';
import pages, * as fromPages from './pages';
import modal, * as fromModal from './modal';
import app, * as fromApp from './app';

/* Reducers: */
const RootReducer = combineReducers({
  app,
  editions,
  themes,
  locations,
  happenings,
  workshops,
  related,
  people,
  pages,
  modal,
  projects,
});

export default RootReducer;

/* Selectors: */

// People
export const getPeople = (state, edition) =>
  fromPeople.getPeople(state.people, edition);

export const getIsPeopleFetching = state =>
  fromPeople.getIsFetching(state.people);

export const getPerson = (state, id) =>
  fromPeople.getPerson(state.people, id);

// Happenings
export const getVisibleHappenings = (state, edition) =>
  fromHappenings.getVisibleHappenings(state.happenings, edition);

export const getIsHappeningsFetching = state =>
  fromHappenings.getIsFetching(state.happenings);

export const getHappening = (state, contentId) =>
  fromHappenings.getHappening(state.happenings, contentId);

export const getIsHappeningFetching = () => { //eslint-disable-line
  return false;
};

// Themes
export const getTheme = (state, edition) =>
  fromThemes.getTheme(state.themes, edition);

export const getIsThemeFetching = state =>
  fromThemes.getIsFetching(state.themes);

// Location
export const getLocation = (state, edition) =>
  fromLocations.getLocation(state.locations, edition);

export const getIsLocationFetching = state =>
  fromLocations.getIsFetching(state.locations);

// Editions
export const getEdition = state =>
  fromEditions.getEdition(state.editions);

export const getAllEditions = state =>
  fromEditions.getAllEditions(state.editions);

export const getIsEditionsFetching = state =>
  fromEditions.getIsFetching(state.editions);

// Workshops
export const getVisibleWorkshops = (state, edition) =>
  fromWorkshops.getVisibleWorkshops(state.workshops, edition);

export const getIsWorkshopsFetching = state =>
  fromWorkshops.getIsFetching(state.workshops);

export const getWorkshop = (state, id) =>
  fromWorkshops.getWorkshop(state.workshops, id);

// Projects
export const getVisibleProjects = (state, edition) =>
  fromProjects.getVisibleProjects(state.projects, edition);

export const getIsProjectsFetching = state =>
  fromProjects.getIsFetching(state.projects);

export const getProject = (state, id) =>
  fromProjects.getProject(state.projects, id);

// Related
export const getRelated = (state, id, type) =>
  fromRelated.getRelated(state.related, id, type);

export const getRelatedTypes = (state, id) => {
  const types = fromRelated.getTypes(state.related, id);
  return types;
};

export const getIsRelatedFetching = state =>
  fromRelated.getIsFetching(state.related);

// Static
export const getStatic = (state, pageId) =>
  fromPages.getPage(state.pages, pageId);

export const getIsPageFetching = (state, pageId) =>
  fromPages.getIsFetching(state.pages, pageId);

// Modal
export const getModalImage = state =>
  fromModal.getModalImage(state.modal);

export const getLang = state =>
  fromApp.getLang(state.app);



// WEBPACK FOOTER //
// ./js/reducers/index.js